import DOMPurify from "dompurify";

import { marked } from "marked";

// Configure marked once to render links that open in new tabs
marked.use({
  renderer: {
    link(token) {
      const href = token.href;
      const title = token.title;
      const text = token.text;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer" ${title ? `title="${title}"` : ""}>${text}</a>`;
    },
  },
});

function renderMarkdown(markdownText) {
  return marked(markdownText);
}
const Message = ({ text, sender }) => {
  return (
    // <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}/>
    // <div className={`message ${sender}`}>
    //     <span className={`message-bubble ${sender}`}>
    //         <div>${renderMarkdown(text)}</div>
    <div
      className={`chat first:mt-auto ${sender === "Human" ? "chat-end" : "chat-start"}`}
    >
      <div
        className="chat-bubble prose"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(renderMarkdown(text), {
            ADD_ATTR: ["target", "rel"],
          }),
        }}
      />
    </div>
    //     </span>
    // </div>
  );
};

export default Message;
